import React, { useState } from 'react';
import { Box, Typography, Paper, Grid, Button } from '@mui/material';
import AddMeasurementsModal from './AddMeasurementsModal';
import './MemberMeasurements.css'; // Import the CSS file

const MemberMeasurements = ({ measurements, memberId, onMeasurementsUpdate }) => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  
  // Add debug logs
  console.log('Measurements received:', measurements);
  console.log('MemberId received:', memberId);

  const handleSaveMeasurements = async (memberId, newMeasurements) => {
    console.log('Saving measurements:', newMeasurements); // Add debug log
    try {
      const response = await fetch('https://jetpriyanshubackend.vercel.app/sangrur_update_measurements', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ _id: memberId, ...newMeasurements }),
      });

      if (response.ok) {
        onMeasurementsUpdate(newMeasurements);
      }
    } catch (error) {
      console.error('Error updating measurements:', error);
    }
  };

  // Modify the condition check to handle edge cases
  if (!measurements || 
      Object.keys(measurements).length === 0 || 
      Object.keys(measurements).every(key => 
        !measurements[key] || 
        measurements[key] === '' || 
        key === 'Name'
      )) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>No measurements data available</Typography>
        <Button 
          variant="contained" 
          onClick={() => setIsAddModalOpen(true)}
          sx={{ mt: 2, bgcolor: '#6d2057' }}
        >
          Add Measurements
        </Button>
        <AddMeasurementsModal
          open={isAddModalOpen}
          onClose={() => setIsAddModalOpen(false)}
          memberId={memberId}
          memberName={measurements?.Name || 'Member'}
          onSave={handleSaveMeasurements}
        />
      </Box>
    );
  }

  // Modify measurementFields to handle null/undefined values
  const measurementFields = [
    { label: 'Weight', value: measurements?.Weight || '', unit: 'kg' },
    { label: 'Chest', value: measurements?.Chest || '', unit: 'inch' },
    { label: 'Stomach', value: measurements?.Stomach || '', unit: 'inch' },
    { label: 'Lower Tier', value: measurements?.LowerTier || '', unit: 'inch' },
    { label: 'Waist', value: measurements?.Waist || '', unit: 'inch' },
    { label: 'Arm', value: measurements?.Arm || '', unit: 'inch' },
    { label: 'Hip', value: measurements?.Hip || '', unit: 'inch' },
    { label: 'Thigh', value: measurements?.Thigh || '', unit: 'inch' }
  ].filter(field => field.value); // Only show fields with values

  return (
    <Box className="member-measurements-container" sx={{ overflowY: 'auto', maxHeight: '100vh' }}>
      <Typography variant="h5" gutterBottom>Body Measurements</Typography>
      <Paper sx={{ p: 2 }}>
        <Grid container spacing={2}>
          {measurementFields.map((field) => (
            field.value && (
              // Changed xs from 12 to 6 to show two columns on mobile
              <Grid item xs={6} sm={6} md={4} key={field.label}>
                <Box className="measurement-field">
                  <Typography variant="subtitle1" color="textSecondary">
                    {field.label}
                  </Typography>
                  <Typography variant="h6">
                    {field.value} {field.unit}
                  </Typography>
                </Box>
              </Grid>
            )
          ))}
        </Grid>
        <Button 
          variant="contained" 
          onClick={() => setIsAddModalOpen(true)}
          className="update-button"
          sx={{ mt: 2, bgcolor: '#6d2057' }}
        >
          Update Measurements
        </Button>
        <Box sx={{ position: 'relative' }}>
          <AddMeasurementsModal
            open={isAddModalOpen}
            onClose={() => setIsAddModalOpen(false)}
            memberId={memberId}
            memberName={measurements?.Name || 'Member'}
            onSave={handleSaveMeasurements}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default MemberMeasurements;